import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import HeroBackgroundOverlay from "./sections/HeroBackgroundOverlay";
import ContactForm from "./sections/ContactForm";
import SuccessStories from "./sections/SuccessStories";
import ContactMethodsGrid from "./sections/ContactMethodsGrid";
import LocationSpotlightSection from "./sections/LocationSpotlightSection";
import ServiceAreaMap from "./sections/ServiceAreaMap";
import OrderContact from "./sections/OrderContact";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <HeroBackgroundOverlay />
      <ContactForm />
      <SuccessStories />
      <ContactMethodsGrid />
      <ServiceAreaMap />
      <LocationSpotlightSection />
      <OrderContact />
      <Footer />
    </div>;
}